<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <br>
      <h1 class="header-style">
        {{ headingText }}
      </h1>
      <br>
      <p class="subheader-style">
        {{ descriptionText }}
      </p>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-dialog
          ref="expiryDialog"
          v-model="expiryCalendar"
          :return-value.sync="documentExpiry"
          width="290px"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="documentExpiry"
              placeholder="Expiry Date"
              outlined
              filled
              readonly
              :rules="requiredRules"
              background-color="transparent"
              hint="Please select the document expiry date."
              color="#37474f"
              dense
              light
              prepend-inner-icon="mdi-calendar-month-outline"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-if="expiryCalendar"
            v-model="documentExpiry"
            full-width
            color="#37474F"
            light
            :min="minExpiryDate"
            @input="$refs.expiryDialog.save(documentExpiry)"
          >
            <v-spacer />
            <v-btn
              text
              color="#37474F"
              @click="expiryCalendar = false"
            >
              Cancel
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-file-input
          id="assetsFieldHandle"
          ref="file"
          v-model="documentFile"
          placeholder="Upload File"
          :rules="sizeRules.concat(fileTypeRules)"
          filled
          clearable
          show-size
          rounded
          dense
          light
          background-color="transparent"
          prepend-inner-icon="mdi-upload"
          prepend-icon=""
          class="ma-0 pa-0 upload-box"
          elevation="0"
          solo
          flat
          accept=".jpg,.jpeg,.png,.pdf"
        />
        <br>
        <p class=" small-style">
          I hereby declare that the document uploaded here is correct and valid. I will present the same when required.
          <v-checkbox
            v-model="agree"
            light
            dense
            color="#FF3700"
            label="I Agree*"
          />
        </p>
      </v-form>
      <v-btn
        class="mt-2 btn-style"
        color="#64CA7F"
        elevation="0"
        @click="acceptDeclaration()"
      >
        Upload
      </v-btn>
      <v-btn
        color="#E6E6E6"
        class="mt-2 btn-style"
        light
        elevation="0"
        @click="showModal = false"
      >
        Cancel
      </v-btn>
      <v-btn
        fab
        color="#E6E6E6"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <centre-spinner :loading="loading" />
    </div>
  </v-dialog>
</template>
<script>
import Constants from 'src/constants';
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
export default {
  name: 'RenewDocuments',
  components: {
    'centre-spinner': spinner,
  },
  props: {
    uploadingDocumentType: {
      type: String,
      default: null,
    },
    selectedOrganization: {
      type: String,
      default: null,
    },
    headingText: {
      type: String,
      default: null,
    },
    descriptionText: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      agree: false,
      showModal: true,
      documentFile: null,
      documentExpiry: '',
      expiryCalendar: false,
      loading: false,
      minExpiryDate: moment().format('YYYY-MM-DD'),
      valid: false,
      sizeRules: [
        value => !value || value.size < 10000000 || 'File size should be less than 10 MB!',
      ],
      requiredRules: [
        v => !!v || 'required field',
      ],
      fileTypeRules: [
        (value) => {
          if (value === null) {
            return 'required field';
          }
          const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            return allowedTypes.includes(value.type) || 'Only PDF, JPG, PNG, and JPEG files are allowed.';
        },
      ],
    };
  },
  computed: {
    userDetails () {
      return this.$store.getters.getUser;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    async acceptDeclaration () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please upload all mandatory documents',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      if (this.agree === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please agree above declaration before proceeding.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      await this.$store.dispatch('register/acceptDeclaration', {
        declarationDetails: {
          declaration_type: 'documentUpload',
          is_agree: this.agree,
          time: moment.utc().format(),
        },
        externalId: this.selectedOrganization,
        appUserId: this.userDetails.app_user.external_id,
      }).then(response => {
        this.loading = false;
        this.uploadDocument();
      }).catch(errors => {
        this.loading = false;
      });
    },
    async uploadDocument () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please upload all mandatory documents',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append('document_file', this.documentFile);
      formData.append('expiry', this.documentExpiry);
      formData.append('document_type_id', this.uploadingDocumentType);
      await this.$store.dispatch('register/uploadDocumentFiles', {
        documentDetails: formData,
        externalId: this.selectedOrganization,
        appUserId: this.userDetails.app_user.external_id,
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Document uploaded successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.showModal = false;
        this.$emit('upload-success');
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.card-style {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.upload-box {
  border: 1px dashed black;
  border-radius: 10px;
}
.v-file-input>>>.v-icon {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.v-file-input>>>.v-input__slot {
  height: 100px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.small-style{
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  color: black;
}
.v-file-input>>>.mdi-close {
  position: absolute;
  top: 50%;
  left: 93%;
  transform: translate(-50%, -50%);
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: rgb(8, 8, 8) !important;
}
</style>
